import { render, staticRenderFns } from "./FactAddMain.vue?vue&type=template&id=3c07f5fc&scoped=true&"
import script from "./FactAddMain.vue?vue&type=script&lang=js&"
export * from "./FactAddMain.vue?vue&type=script&lang=js&"
import style0 from "./FactAddMain.vue?vue&type=style&index=0&id=3c07f5fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c07f5fc",
  null
  
)

export default component.exports